// extracted by mini-css-extract-plugin
export default {"root":"ConfirmUserDeleteModal_root__HOhmG","container":"ConfirmUserDeleteModal_container__iuwyU","footer":"ConfirmUserDeleteModal_footer__wZefB"};